/** @module envUtils */

/**
 * @see {@link /docs/utils/env.md|Environment documentation}
 */
const DEVELOPMENT = 'development';
const DETECTIVE = 'detective';
const STAGING = 'staging';
const PROD = 'prod';
const TEST = 'test';
const DEFAULT_APP_CUSTOMER = 'default';

const appEnv = process.env.APP_ENV;
const appVersion = process.env.APP_VERSION;
const appCustomer = process.env.APP_CUSTOMER || DEFAULT_APP_CUSTOMER;
const appPlatform = process.env.PELO_PLATFORM;

const isDevelopmentApp = appEnv === DEVELOPMENT;
const isDetectiveApp = appEnv === DETECTIVE;
const isStagingApp = appEnv === STAGING;
const isProdApp = appEnv === PROD;
const isTestApp = appEnv === TEST;

module.exports = {
  appCustomer,
  appEnv,
  appPlatform,
  appVersion,
  isDetectiveApp,
  isDevelopmentApp,
  isProdApp,
  isStagingApp,
  isTestApp,
};
